"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _lodash = require("lodash");
var _LoadCalculator = _interopRequireDefault(require("../../components/LoadCalculator"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to display a single calculator
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A single calculator
 */
function CalculatorCard(props) {
  var extractedFields;
  if (props.rendering.fields) {
    extractedFields = (0, _utils.extractFieldsFn)(props);
    var mainBody = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !(0, _lodash.isEmpty)(extractedFields.Calculators.fields.StepsContent) && !(0, _lodash.isNull)(extractedFields.Calculators.fields.Type) && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_LoadCalculator.default, {
      items: extractedFields.Calculators.fields.StepsContent,
      type: extractedFields.Calculators.fields.Type.fields.calcType,
      env: props.params.env,
      apiUrl: extractedFields.Calculators.fields.Type.fields.apiUrl.value,
      showBorder: extractedFields.DisplayBorder.value,
      icon: extractedFields.Calculators.fields.Icon.value,
      title: extractedFields.Calculators.fields.Title.value,
      forcedSingleColumn: extractedFields.DisplaySideBarBelowCalc.value,
      sideBarBoxVariant: extractedFields.Calculators.fields.SideBarBoxVariant.value,
      hideNext: extractedFields.Calculators.fields.HideNext,
      CONTENT_API_CALC_PDF: "/apicalls/downloadpdf/calcpdf"
    })));
    return /*#__PURE__*/_react.default.createElement("div", {
      id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
      className: "app-container"
    }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
      variant: 'basic no-border'
    }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, mainBody)));
  } else return null;
}
var _default = exports.default = CalculatorCard;